import * as actions from "../actions/actions";
import { connect } from "react-redux";

let raven = require("../legacy/helpers/raven_client").default;
import React from "react";

let get_parameter_by_name = require("../legacy/helpers/get_parameter_by_name")
    .default;
import PluginNavigation from "../components/nounproject-plugin-navigation";

class NounProjectPluginWrapper extends React.Component {
    componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.currentUser !== undefined) {
            if (!nextState.hasSetRavenUser) {
                this.setState({
                    hasSetRavenUser: true
                });
                raven.setUserContext({
                    id: nextProps.currentUser.id
                });
            }
        }
        if (nextProps.host === "office") {
            if (!nextState.officeIntialized) {
                this.setState({
                    officeIntialized: true
                });
                document.addEventListener("DOMContentLoaded", function(event) {
                    Office.initialize = function(reason) {
                        raven.setTagsContext({
                            application: Office.context.host,
                            platform: Office.context.platform
                        });
                    };
                });
            }
        }

        if (nextProps.host === "adobe") {
            if (!nextState.adobeInitialized) {
                this.setState({
                    adobeInitialized: true
                });
                document.addEventListener("DOMContentLoaded", function(event) {
                    nextProps.setAdobeAgent();
                });
            }
        }
    }

    constructor(props) {
        super(props);

        let searchTerm = location.hash.split("/")[2];

        if (searchTerm) {
            if (searchTerm.includes("?")) {
                searchTerm = searchTerm.split("?")[0];
            }
        }

        this.props.getCurrentUser();

        if (!props.host) this.props.setPluginHost(window.plugin_host);
        this.props.setSearchTerm(searchTerm);
        this.props.setPage(
            getHostQuery("page") === null ? "1" : getHostQuery("page")
        );

        window.handleLink = function handleLink(e) {
            if (window._nounConfig.pluginHost === "adobe") {
                e.preventDefault();
                let url = e.target.href,
                    csInterface = new CSInterface();
                if (e.target.nodeName != "A") {
                    // Sometime e.target is not the link tag, so get it from the currentTarget
                    url = e.currentTarget.href;
                }
                csInterface.openURLInDefaultBrowser(url);
            }
        };
    }

    render() {
        let navigation = this.renderNavigation();

        return (
            <div style={{ height: "100%" }}>
                {navigation}
                {this.props.children}
            </div>
        );
    }

    renderNavigation() {
        return <PluginNavigation />;
    }
}

function getHostQuery(name) {
    let regex;
    let results;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    results = regex.exec(location.href);
    if (results === null) {
        return null;
    } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser,
        host = state.plugin.host;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return { currentUser, host };
}

module.exports = connect(mapStateToProps, {
    setAdobeAgent: actions.setAdobeAgent,
    setPage: actions.setPage,
    getCurrentUser: actions.getCurrentUser,
    setPluginHost: actions.setPluginHost,
    setSearchTerm: actions.setSearchTerm
})(NounProjectPluginWrapper);
